//------------------------------------------------------ externos
import { useEffect, useState } from "react";
//------------------------------------------------------ elementos
import FormContent from "../funcionales/FormContent";
import MarcoModal from "../funcionales/MarcoModal";
import FormHeader from "../funcionales/FormHeader";
import TextButton from "../buttons/TextButton";
import Loading from "../../routes/Loading";
//------------------------------------------------------ funciones
import { cargarSelects } from "../../functions/dataFunctions";
import { submitProveedor } from "./data/Submits";
import { elementos } from "./data/FormContent";
//import { refreshCache } from "../../services/cache";
//------------------------------------------------------ estilos
import "./css/Forms.css";

const FormProveedor = ({ elemento = null, onGuardar, onClose }) => {
  const modoEdicion = !!elemento;
  const titulo = modoEdicion ? "Editar" : "Agregar";
  const subtitulo = "Proveedor";
  const campos = elementos["proveedores"];

  const [loading, setLoading] = useState(true);
  const [listas, setListas] = useState({}); //para los selects, recibe un array tipo {tractores: ..., furgones: ...}
  const [formData, setFormData] = useState({
    // información específica
    id: elemento?.id || "",
    cuit: elemento?.cuit || "",
    nombre: elemento?.nombre || "",
    marca: elemento?.marca || "",
    // detalles y comentarios
    detalle: elemento?.detalle || "",
  });

  useEffect(() => {
    const cargarDatos = async () => {
      const data = await cargarSelects(); // trae TODOS los listados, ver si se puede mejorar desp
      setListas(data);
    };

    cargarDatos();
    setLoading(false);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    await submitProveedor(
      formData,
      campos,
      setLoading,
      onGuardar,
      onClose,
      modoEdicion,
      elemento?.id,
    );
  };

  return (
    <MarcoModal onClose={onClose}>
      {loading ? (
        <Loading />
      ) : (
        <div className="form-content">
          <FormHeader title={titulo} subTitle={subtitulo} onClose={onClose} />

          <FormContent
            elemento={elemento}
            campos={campos}
            opciones={listas}
            data={formData}
            setData={setFormData}
          />

          <div className="form-buttons">
            <TextButton
              text={"Guardar"}
              type={"button"}
              onClick={handleSubmit}
            />
          </div>
        </div>
      )}
    </MarcoModal>
  );
};

export default FormProveedor;
